<script>
  import MenuItem from "./MenuItem.svelte";
  import {ServiceMenu} from "@util/constant"
</script>


<MenuItem Menu={ServiceMenu} />
